import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { css } from 'emotion'
import * as React from 'react'

const ChevronDown = require('assets/components/chevron-down.svg')
const ChevronUp = require('assets/components/chevron-up.svg')

const styles = require('./styles.scss')
export interface AccordionProps {
  children: JSX.Element[]
  collapsed: boolean
  maxHeight?: number
  minItemsShown?: number
  paddingRight?: number
  accordionPaddingLeft?: boolean
  toggleFullWidth?: boolean
  showMask?: boolean
  cta?: JSX.Element
  features?: JSX.Element
}

export const MIN_ACCORDION_DISPLAY_ITEMS = 3

export const Accordion = ({
  children = [],
  collapsed,
  maxHeight,
  minItemsShown = MIN_ACCORDION_DISPLAY_ITEMS,
  paddingRight = 240,
  accordionPaddingLeft = true,
  toggleFullWidth = false,
  showMask = true,
  cta,
  features,
}: AccordionProps) => {
  const elementRef = React.useRef<HTMLUListElement>(null)

  const [isCollapsed, setIsCollapsed] = React.useState(collapsed)

  const toggleDetailsContainer = () => {
    setIsCollapsed(!isCollapsed)
  }

  const ToggleButton = () => {
    const icon = isCollapsed ? <ChevronDown /> : <ChevronUp />
    const text = isCollapsed ? 'Expand Details' : 'Hide Details'

    return (
      <ThemeConsumer>
        {({ fontSizeBase, fontFamilySecondary, ctaStyles }) => (
          <>
            <div
              className={classnames(
                styles.toggleButtonContainer,
                styles.breakpointLarge,
                css`
                  padding-right: ${paddingRight}px;
                  margin: ${toggleFullWidth ? '0px 0px -20px 0px' : 'auto'};
                `,
              )}
            >
              <div className={styles.toggleDetailsTextWrapper} onClick={toggleDetailsContainer}>
                <span
                  className={classnames(
                    styles.toggleDetailsText,
                    css`
                      color: ${ctaStyles?.backgroundColor};
                      font-family: ${fontFamilySecondary};
                      font-size: ${fontSizeBase};
                    `,
                  )}
                >
                  {text}
                </span>
                <span
                  className={classnames(
                    styles.iconContainer,
                    css`
                      fill: ${ctaStyles?.backgroundColor};
                    `,
                  )}
                >
                  {icon}
                </span>
              </div>
              {cta}
              {features}
            </div>
            <div>
              <div className={classnames(styles.breakpointMediumBlock, styles.breakpointSmallBlock)}>{features}</div>
              <div
                className={classnames(
                  styles.toggleButtonContainer,
                  styles.breakpointMedium,
                  styles.breakpointSmall,
                  css`
                    padding-right: ${paddingRight}px;
                    margin: ${toggleFullWidth ? '0px 0px -20px 0px' : 'auto'};
                    justify-content: space-between;
                  `,
                )}
              >
                <div className={styles.toggleDetailsTextWrapper} onClick={toggleDetailsContainer}>
                  <span
                    className={classnames(
                      styles.toggleDetailsText,
                      css`
                        color: ${ctaStyles?.backgroundColor};
                        font-family: ${fontFamilySecondary};
                        font-size: ${fontSizeBase};
                      `,
                    )}
                  >
                    {text}
                  </span>
                  <span
                    className={classnames(
                      styles.iconContainer,
                      css`
                        fill: ${ctaStyles?.backgroundColor};
                      `,
                    )}
                  >
                    {icon}
                  </span>
                </div>
                {cta}
              </div>
            </div>
          </>
        )}
      </ThemeConsumer>
    )
  }

  return (
    <div data-test-id="accordion" className={classnames(styles.offerDetails)}>
      <ToggleButton />
      <ul
        data-test-id="details-list"
        className={classnames(
          styles.detailsList,
          {
            [styles.masked]: showMask && isCollapsed,
            [styles.detailsCollapsed]: isCollapsed,
          },
          css`
            padding-left: ${accordionPaddingLeft ? 'auto' : 0};
          `,
        )}
      >
        {children}
      </ul>
    </div>
  )
}
